import getConfig from '../get-config';

export default function isFoodora() {
  const foodora_code = 'FO';

  const config = getConfig();

  return config.entity.code == foodora_code;
}
